
import styled from 'styled-components'

const FormSubmit = styled.div`
    display: block;
    width: 100%;
    margin-top: 24px;
    button {
        width: 100%;
    }
`;

export default FormSubmit;